import { render, staticRenderFns } from "./expandable-panel.vue?vue&type=template&id=21a8c83e&scoped=true"
import script from "./expandable-panel.vue?vue&type=script&lang=js"
export * from "./expandable-panel.vue?vue&type=script&lang=js"
import style0 from "./expandable-panel.vue?vue&type=style&index=0&id=21a8c83e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a8c83e",
  null
  
)

export default component.exports